import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import OurServicesPage from './components/OurServicesPage';
import ContentMarketing from './components/ContentMarketing';
import LeadGeneration from './components/LeadGeneration';
import WebDesign from './components/WebDesign';
import EmailMarketing from './components/EmailMarketing';
import SocialMarketing from './components/SocialMarketing';
import MarketingAutomation from './components/MarketingAutomation';
import OurStoryPage from './components/OurStoryPage';
import ppc from './components/ppc';
import SEO from './components/SEO';
import abm from './components/abm';
import Footer from './components/Footer';
import Portfolio from './components/Portfolio';
import SuccessStories from './components/SuccessStories';
import Contact from './components/Contact';
import Ebook from './components/Ebook';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Switch>
        <Route path="/" exact component={Home} /> {/* Route for Home page */}
        <Route path="/our-services" exact component={OurServicesPage} /> {/* Route for OurServicesPage */}
        <Route path="/abm" exact component={abm} /> 
        <Route path="/ContentMarketing" exact component={ContentMarketing} /> 
        <Route path="/LeadGeneration" exact component={LeadGeneration} /> 
        <Route path="/WebDesign" exact component={WebDesign} /> 
        <Route path="/SEO" exact component={SEO} /> 
        <Route path="/EmailMarketing" exact component={EmailMarketing} />
        <Route path="/SocialMarketing" exact component={SocialMarketing} />
        <Route path="/ppc" exact component={ppc} />
        <Route path="/MarketingAutomation" exact component={MarketingAutomation} />
        <Route path="/OurStory" exact component={OurStoryPage} />
        <Route path="/Portfolio" exact component={Portfolio} />
        <Route path="/SuccessStories" exact component={SuccessStories} />
        <Route path="/Contact" exact component={Contact} />
        <Route path="/Ebook" exact component={Ebook} />
        {/* Add more routes as needed */}
      </Switch>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
